import _ from 'lodash'
import { isCPF, isCNPJ } from 'brazilian-values'

export const cpfValid = (string) => {
  return _.isString(string) && isCPF(string)
}

export const cnpjValid = (string) => {
  return _.isString(string) && isCNPJ(string)
}

export function phoneValidator(phone) {
  const validRegex = /^\([1-9][0-9]\) [9][1-9][0-9]{3}-[0-9]{4}$/
  return validRegex.test(phone)
}

export const ValidateEmail = (email) => {
  const validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

  return validRegex.test(email)
}

export const ValidatePassword = (password) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&])[A-Za-z\d@$#!%*?&]{10,18}$/
  
  return passwordRegex.test(password)
}
